
export default function AboutSection() {
  const capabilities = [
    {
      title: "Robotics Engineering",
      description: "Advanced humanoids and AMR/AGF systems designed for industrial environments"
    },
    {
      title: "Safety Systems Integration",
      description: "Comprehensive safety protocols and sensor integration for human-robot collaboration"
    },
    {
      title: "Workforce Operations",
      description: "Nationwide staffing and outsourcing network through BrainCommerce ecosystem"
    },
    {
      title: "Deployment Expertise",
      description: "End-to-end implementation from site survey to full-scale operations"
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">About BC Robotics</h2>
            <div className="text-xl text-gray-600 leading-relaxed space-y-4">
              <p>
                BC Robotics is the industrial robotics division of BrainCommerce, combining 
                cutting-edge automation technology with proven workforce operations expertise.
              </p>
              <p>
                Our unique positioning within the BrainCommerce ecosystem enables us to deliver 
                not just robotic solutions, but comprehensive workforce transformation that 
                seamlessly integrates technology with human capabilities.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/89ce65a415860e3da90921dded83bf21/05ead0b90169ca6b0be55a53d3c106c2.png"
              alt="BrainCommerce Headquarters"
              className="w-full rounded-2xl shadow-lg object-cover object-top"
            />
            <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold text-blue-600">KRW 430B</div>
              <div className="text-sm text-gray-600">BrainCommerce Ecosystem</div>
            </div>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-blue-50 to-gray-50 rounded-3xl p-8 lg:p-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Combined Capabilities</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {capabilities.map((capability, index) => (
              <div key={index} className="flex items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-4 flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">{capability.title}</h4>
                  <p className="text-gray-600 leading-relaxed">{capability.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
